function abbreviateMeditationContent(state) {
    // if (!state) return null;
    // const abb = state;
    // const first = abb[0];
    // console.log(first);
    // try {
    //     abb.forEach((i) => {
    //         abb[i].content = ;
    //     });
    // } catch (err) {
    //     sanitary.start_date = formatDate(stateData.start_date);
    // }
    // console.log('hi');
    // return abb[0];
}

export default {
    meditations(state) {
        return state.meditations;
    },
    error(state) {
        return state.error;
    },
    abbreviatedMeditationContent(state) {
        return abbreviateMeditationContent(state.meditations);
    }
};
